import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { useEffect, useRef, useState, useContext } from "react";
import Banner from "../../../components/banner";
import Breadcrumb from "../../../components/__simple/breadcrumb";
import { useDispatch } from "react-redux";
import { changeHeader } from "../../../_redux/slices/navSlice";
import OverViewContext from "../overviewContext";
import config from "../../../configuration/config";
export function CarBanner({ name, desc, bg, url, brand, onBuyClick, pdf = null, hasOffers = false, breadcrumb, setSectionActive, logo, siteDesc }) {
    const { t: trans, i18n } = useTranslation(["common", "vehicales", "info"]);
    const navRef = useRef(null);
    const [navFlex, setNavFlex] = useState(false);
    let lang = (i18n.language || 'ar');
    const languageDir = 'language-' + lang;
    const dispatch = useDispatch();
    const context = useContext(OverViewContext);
    const [pageName, setPageName] = useState(breadcrumb ?? trans("vehicales:veh-d-home-public"));

    useEffect(() => {
        dispatch(
            changeHeader({ isFixed: false })
        )
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll)
            dispatch(
                changeHeader({ isFixed: true })
            )
        };
    }, [url, dispatch]);

    useEffect(() => {
        setPageName(breadcrumb ?? trans("vehicales:veh-d-home-public"));

    }, [breadcrumb, trans]);

    const handleScroll = () => {
        const currentScrollY = window.scrollY;

        // Restore old sticky threshold logic (e.g. after the banner)
        if (currentScrollY > 540) {
            setNavFlex(true)
        } else {
            setNavFlex(false);
        }
    };

    return (
        <div className="bg-white dark:bg-[#121212] relative z-10">
            {/* ═══ BANNER IMAGE ═══ */}
            <div className="margin-top-for-under-header">
                <Banner background={bg} overlay={false} />
            </div>

            <div className="container relative z-20 mt-20 bg-transparent">


                {/* ═══ STICKY NAVBAR ═══ */}
                <div ref={navRef}
                    className={"mb-16 bg-white dark:bg-[#1c1c1e] car-navbar " + (navFlex ? "car-navbar-fixed " : "")}>
                    <div className="car-navbar-links">
                        {/* DESKTOP/MOBILE NAME - Hidden on Mobile */}
                        <h2 className={"name text-24 font-bold hide-xs " + languageDir}>{name}</h2>

                        {/* NAVIGATION LINKS - Always visible, centered on mobile */}
                        <div className={"car-navbar-links-group " + languageDir}>
                            <NavLink exact activeClassName="active" onClick={() => { setSectionActive("public"); setPageName(trans("vehicales:veh-d-home-public")) }} to={`${url}`}>{trans("vehicales:veh-d-home-public")}</NavLink>
                            <NavLink activeClassName="active" onClick={() => { setSectionActive("gallery"); setPageName(trans("vehicales:veh-d-home-gallery")) }} to={`${url}/gallery`}>{trans("vehicales:veh-d-home-gallery")}</NavLink>
                            <NavLink activeClassName="active" onClick={() => { setSectionActive("feature"); setPageName(trans("vehicales:veh-d-home-feature")) }} to={`${url}/feature`}>{trans("vehicales:veh-d-home-feature")}</NavLink>
                            <NavLink activeClassName="active" onClick={() => { setSectionActive("specs"); setPageName(trans("vehicales:veh-d-home-specs")) }} to={`${url}/specs`}>{trans("vehicales:veh-d-home-specs")}</NavLink>
                            <NavLink activeClassName="active" onClick={() => { setSectionActive("comparison"); setPageName(trans("vehicales:veh-d-home-comparison")) }} to={`${url}/comparison`}>{trans("vehicales:veh-d-home-comparison")}</NavLink>
                        </div>

                        {/* LOGO - Hidden on Mobile via SCSS or hide-xs */}
                        {logo && (
                            <div className="car-navbar-links-logo hide-xs">
                                <img src={config.FilePathURL + logo} alt="" />
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* ═══ TITLE & BREADCRUMB SECTION ═══ */}
            <div className="container mb-12 sm:mb-32 relative z-10">
                {/* <Breadcrumb
                    links={[
                        {
                            name: brand,
                            to: "/vehicles/" + brand
                        },
                        {
                            name: name,
                            to: url
                        },
                        {
                            name: pageName,
                        }
                    ]}
                /> */}

                <div className={"car-heading " + languageDir}>
                    <div className="car-heading-name w-100">
                        {/* <h1 className="text-ellipsis" title={name}>{name}</h1> */}
                        <div className="car-tags mb-4">
                            {context.vehicleInfo?.isNew && <span className="tag primary" style={{ background: 'var(--g)', color: '#fff', padding: '5px 15px', borderRadius: '20px', fontSize: '12px', fontWeight: '800' }}>{trans("info:new")}</span>}
                            {context.vehicleInfo?.isHybird && <span className="tag hybrid" style={{ background: '#00bcd4', color: '#fff', padding: '5px 15px', borderRadius: '20px', fontSize: '12px', fontWeight: '800' }}>{trans("vehicales:veh-hybrid")}</span>}
                        </div>
                    </div>
                    {siteDesc && <div className="car-heading-desc">
                        {siteDesc}
                    </div>}
                    {pdf && (
                        <div className="car-heading-menu">
                            <a href={config.mainURL + pdf} target="_blank" rel="noreferrer" className="hdr-btn ghost" style={{ display: 'inline-flex', marginTop: '16px' }}>
                                <svg viewBox="0 0 24 24" style={{ width: '16px', height: '16px' }}><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" /><polyline points="14 2 14 8 20 8" /></svg>
                                {trans("vehicales:veh-d-home-userGuid")}
                            </a>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}


